import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ANDROID_APP_LINK, IOS_APP_LINK } from '@src/app/core/constants/system-list.constant';
import { SharedDataService } from '@src/app/core/services';
import { MiniEnvHeadingBlockComponent } from '../../ui/heading-box/mini-env-heading-block/mini-env-heading-block.component';

@Component({
  selector: 'app-mini-env-sub-footer',
  imports: [CommonModule, MiniEnvHeadingBlockComponent],
  templateUrl: './mini-env-sub-footer.component.html',
  styleUrl: './mini-env-sub-footer.component.scss'
})
export class MiniEnvSubFooterComponent {
  appStoreUrl = IOS_APP_LINK;
  googlePlayUrl = ANDROID_APP_LINK;
  // An empty link means this tenant has no app on that store.
  hasAppLinks = !!this.appStoreUrl || !!this.googlePlayUrl;
  sharedService = inject(SharedDataService);
}
